import React, { Component } from 'react'
import * as Sentry from '@sentry/browser'
import logger from 'logger'
import Page500 from 'pages/Page500/Page500'


class ErrorBoundary extends Component<{ children?: React.ReactNode }, { error: Error | null, sentryEventId: string }> {

  state = {
    error: null,
    sentryEventId: null,
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error(error, {
      extra: errorInfo,
    })

    const sentryEventId = Sentry.lastEventId()

    this.setState({
      error,
      sentryEventId,
    })
  }

  render() {
    const { error, sentryEventId } = this.state

    if (error) {
      return (
        <Page500 error={error} sentryEventId={sentryEventId} />
      )
    }

    return (
      <>{this.props.children}</>
    )
  }
}


export default ErrorBoundary
